import { config } from 'client/hooks/config';
import type * as api from 'common/types/api';
import { Api } from 'common/utils/api';
import { useQuery } from 'react-query';

type Response = api.SearchFacilitiesResponse;

export function useListEpicFacilities() {
    const { key, path } = config.epic.listFacilities();

    const result = useQuery([key], () => Api.get<Response>({ path }));

    return {
        facilities: result.data ?? [],
        isLoading: result.isLoading,
        isFetching: result.isFetching,
    };
}
